import { MatchTimeResponse } from 'models';
import { useEffect, useState } from 'react';

export const useMatchTimeCountdown = (matchTime: MatchTimeResponse) => {
  const [countdown, setCountdown] = useState<string | null>(null);

  useEffect(() => {
    if (
      !matchTime ||
      !matchTime.isClockRunning ||
      matchTime.isMatchFinished ||
      !matchTime.timeStampUtc ||
      !matchTime.timeRemainingInPhaseMilliseconds
    ) {
      setCountdown(null);
      return;
    }

    const startTime = new Date(matchTime.timeStampUtc).getTime();
    const durationMs = parseInt(matchTime.timeRemainingInPhaseMilliseconds);
    let animationFrameId: number;

    const tick = () => {
      const now = Date.now();
      const elapsed = now - startTime;
      const remaining = durationMs - elapsed;

      if (remaining <= 0) {
        setCountdown('0:00');
        return;
      }

      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      const formatted = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      setCountdown(formatted);

      animationFrameId = requestAnimationFrame(tick);
    };

    tick();

    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [
    matchTime.fixtureId,
    matchTime.isClockRunning,
    matchTime.isMatchFinished,
    matchTime.timeStampUtc,
    matchTime.timeRemainingInPhaseMilliseconds,
  ]);

  return countdown;
};
